import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AllCategoryTopic = () => {
  const [category, setCategory] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [datas, setDatas] = useState([]);

  // CLASSES DATA GET FUN AXIOS --
  const getCategory = () => {
    axios
      .get(`${API_BASE_URL}/category`)
      .then((resp) => {
        console.log(resp);
        const { data } = resp.data;
        setCategory(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCategory();
  }, []);

  const getAllTopics = () => {
    axios
      .get(`${API_BASE_URL}/topics?categoryId=${categoryId}`)
      .then((response) => {
        // console.log(response);
        setDatas(response.data?.topics);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllTopics();
  }, [categoryId]);

  const handleAddNewCategory = () => {
    navigate("/add-category-topic");
  };

  const handleViewAllCategory = () => {
    navigate("/all-category-topic");
  };

  // API DELETE FUN
  let handleSchoolClassDlt = async (id) => {
    let dltOrNot = window.confirm("Do you want to delete");
    if (dltOrNot) {
      axios
        .delete(`${API_BASE_URL}/admin/topics/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((resp) => {
          console.log(resp);
          getAllTopics();
        });
    }
  };

  const handleEdit = (id) => {
    navigate(`/edit-category-topic/${id}`);
  };

  return (
    <>
      <div id="classes-inner-wrapper">
        <div className="classes-header-div">
          <h5>Category Topics</h5>
          <div className="classes-header-btns">
            <button className="add-class-btn" onClick={handleAddNewCategory}>
              + Add New Category Topic
            </button>
            <button className="all-classes-btn" onClick={handleViewAllCategory}>
              All Category Topics
            </button>
          </div>
        </div>

        <div className="classes-table-container">
          <h5>All Category Topics</h5>
          <div className="college-course-detail-form">
            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Category</label>
              <select
                className="new-chapter-dropdown"
                value={categoryId}
                onChange={(e) => setCategoryId(e.target.value)}
              >
                <option value="">-Select Category-</option>
                {category.map((item, idx) => (
                  <option key={idx} value={item?._id}>
                    {item?.category}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <table className="classes-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Category Topics</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {datas &&
                [...datas].reverse().map((item, idx) => (
                  <tr key={item?._id}>
                    <td>{idx + 1}</td>
                    <td>{item?.topic}</td>
                    <td className="table-action-icons">
                      <i
                        className="fa-solid fa-file-pen"
                        onClick={() => handleEdit(item?._id)}
                      ></i>
                      <i
                        className="fa-solid fa-trash-can"
                        onClick={() => handleSchoolClassDlt(item?._id)}
                      ></i>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AllCategoryTopic;
